
      // Temporary workaround for @patternfly/react-topology using global
      globalThis.global ||= globalThis;
    